import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Loader2 } from "lucide-react";
import adminApi, { apiError } from "@/services/adminApi";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await adminApi.login(username.trim(), password);
      localStorage.setItem("admin_token", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0c] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center mb-4">
            <ShieldCheck className="w-7 h-7 text-amber-500" />
          </div>
          <h1 className="text-xl font-bold text-white">Fibernet TV Admin</h1>
          <p className="text-sm text-zinc-500 mt-1">İdarəetmə panelinə giriş</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4 bg-zinc-900/60 border border-zinc-800 rounded-2xl p-6">
          <input
            data-testid="admin-username-input"
            type="text"
            placeholder="İstifadəçi adı"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-4 py-2.5 bg-zinc-800/80 border border-zinc-700/40 rounded-lg text-sm text-white placeholder-zinc-500 focus:outline-none focus:border-amber-500/50"
          />
          <input
            data-testid="admin-password-input"
            type="password"
            placeholder="Şifrə"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-2.5 bg-zinc-800/80 border border-zinc-700/40 rounded-lg text-sm text-white placeholder-zinc-500 focus:outline-none focus:border-amber-500/50"
          />
          {error && <p data-testid="admin-login-error" className="text-sm text-red-400">{error}</p>}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading || !username || !password}
            className="w-full py-2.5 bg-amber-500 hover:bg-amber-400 disabled:opacity-50 text-black font-semibold rounded-lg transition-colors text-sm flex items-center justify-center gap-2"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Daxil ol
          </button>
        </form>
      </div>
    </div>
  );
}
